/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withStore } from 'fierry/react';


const getInitialState = () =>
{
  return Date.now();
};


const refresh = () =>
{
  return Date.now();
};


export default withStore(getInitialState, { refresh });
